import React, { useState, useEffect, useContext } from "react";
import Parse from "parse";
import { v4 as uuidv4 } from "uuid";
import { Context } from "../../utils/Context";

import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";

Parse.initialize(
  "FCdW0v97ycNx7HNsJhTxsAGJP1Cm5441F2dDt6mn",
  "0A4aIECXyyG7bo3phYAGGNlwsgIwYrDpaaqbD8ou"
);
Parse.serverURL = "https://parseapi.back4app.com/";

const InstallPWA = ({ open, handleClose }) => {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const { setInstalled, latitude, longitude } = useContext(Context);

  useEffect(() => {
    const handleBeforeInstallPrompt = (event) => {
      event.preventDefault();
      setDeferredPrompt(event);
    };

    window.addEventListener("beforeinstallprompt", handleBeforeInstallPrompt);

    return () => {
      window.removeEventListener(
        "beforeinstallprompt",
        handleBeforeInstallPrompt
      );
    };
  }, []);

  const sendInstallationData = (latitude, longitude) => {
    const Installation = Parse.Object.extend("Installation");
    const installationData = new Installation();

    installationData.set("deviceId", uuidv4());
    installationData.set("installationId", uuidv4());
    installationData.set("appVersion", "1.0");
    installationData.set("appName", "mygender_app");
    installationData.set("timeZone", latitude + "," + longitude);

    installationData.save().then(
      (result) => {
        console.log("Installation data sent successfully:", result);
      },
      (error) => {
        console.error("Error sending installation data:", error);
      }
    );
  };

  const handleInstallClick = () => {
    if (deferredPrompt) {
      deferredPrompt.prompt();

      deferredPrompt.userChoice.then((choiceResult) => {
        if (choiceResult.outcome === "accepted") {
          console.log("User accepted the install prompt");
          sendInstallationData(latitude, longitude);
          setInstalled(true);
          handleClose();
        } else {
          console.log("User dismissed the install prompt");
        }

        setDeferredPrompt(null);
      });
    }
  };

  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle
        style={{
          fontWeight: 700,
          fontFamily: "Inter, Helvetica, sans-serif",
          fontSize: "2rem",
          textAlign: "center",
        }}
      >
        Adicionar à tela inicial
      </DialogTitle>
      <DialogContent>
        <p
          style={{
            fontWeight: 500,
            fontFamily: "Inter, Helvetica, sans-serif",
            fontSize: "1.25rem",
            textAlign: "center",
            margin: 0,
          }}
        >
          Pode adicionar esta aplicação ao seu ecrã principal para uma melhor
          experiência de utilização!
        </p>
      </DialogContent>

      <DialogActions sx={{ textAlign: "center" }}>
        <Button
          variant="contained"
          color="success"
          onClick={handleInstallClick}
          autoFocus
        >
          Instalar
        </Button>
        <Button variant="outlined" onClick={handleClose} color="primary">
          Fechar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default InstallPWA;
